import React from 'react';
import { Link } from 'react-router-dom';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Monitor, Users, GraduationCap, Headphones, Building2, DollarSign, Briefcase, MapPin, CreditCard, FileText, BarChart, Shield } from 'lucide-react';
const businessCategories = [{
  icon: Monitor,
  label: 'CRMs & POS',
  count: 12
}, {
  icon: Users,
  label: 'Recruiting',
  count: 8
}, {
  icon: GraduationCap,
  label: 'Training',
  count: 6
}, {
  icon: Headphones,
  label: 'Support Services',
  count: 5
}, {
  icon: CreditCard,
  label: 'Payroll Systems',
  count: 4
}, {
  icon: BarChart,
  label: 'Lead Gen',
  count: 7
}];
const repCategories = [{
  icon: Building2,
  label: 'Industries',
  count: 6
}, {
  icon: DollarSign,
  label: 'Compensation',
  count: 9
}, {
  icon: Briefcase,
  label: 'Work Models',
  count: 4
}, {
  icon: MapPin,
  label: 'Territories',
  count: 15
}, {
  icon: FileText,
  label: 'Career Paths',
  count: 5
}, {
  icon: Shield,
  label: 'Company Reviews',
  count: 24
}];
function CategoryCard({
  icon: Icon,
  label,
  count,
  id
}: {
  icon: any;
  label: string;
  count: number;
  id: string;
}) {
  return <Link to={`/category/${id}`} className="flex flex-col items-center justify-center p-6 bg-white border border-slate-200 rounded-lg hover:border-teal-300 hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 group" data-id="element-124">
      <div className="w-10 h-10 bg-slate-50 rounded-full flex items-center justify-center mb-3 group-hover:bg-teal-50 transition-colors" data-id="element-125">
        <Icon className="w-5 h-5 text-slate-500 group-hover:text-teal-600 transition-colors" data-id="element-126" />
      </div>
      <span className="text-sm font-semibold text-slate-900 mb-1 text-center" data-id="element-127">
        {label}
      </span>
      <span className="text-xs text-slate-500 bg-slate-100 px-2 py-0.5 rounded-full group-hover:bg-teal-50 group-hover:text-teal-700 transition-colors" data-id="element-128">
        {count} Guides
      </span>
    </Link>;
}
export function CategoryBrowseSection() {
  const businessCats = [{
    icon: Monitor,
    label: 'CRMs & POS',
    count: 12,
    id: 'crms'
  }, {
    icon: Users,
    label: 'Recruiting',
    count: 8,
    id: 'recruiting'
  }, {
    icon: GraduationCap,
    label: 'Training',
    count: 6,
    id: 'training'
  }, {
    icon: Headphones,
    label: 'Support Services',
    count: 5,
    id: 'support'
  }, {
    icon: CreditCard,
    label: 'Payroll Systems',
    count: 4,
    id: 'payroll'
  }, {
    icon: BarChart,
    label: 'Lead Gen',
    count: 7,
    id: 'lead-gen'
  }];
  const repCats = [{
    icon: Building2,
    label: 'Industries',
    count: 6,
    id: 'industries'
  }, {
    icon: DollarSign,
    label: 'Compensation',
    count: 9,
    id: 'compensation'
  }, {
    icon: Briefcase,
    label: 'Work Models',
    count: 4,
    id: 'work-models'
  }, {
    icon: MapPin,
    label: 'Territories',
    count: 15,
    id: 'territories'
  }, {
    icon: FileText,
    label: 'Career Paths',
    count: 5,
    id: 'career-paths'
  }, {
    icon: Shield,
    label: 'Company Reviews',
    count: 24,
    id: 'company-reviews'
  }];
  return <SectionWrapper id="categories" data-id="element-129">
      <div className="mb-12" data-id="element-130">
        <h2 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-131">
          Browse by Category
        </h2>
        <p className="text-slate-600" data-id="element-132">
          Explore our comprehensive directory of guides and reviews.
        </p>
      </div>

      <div className="mb-10" data-id="element-133">
        <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 border-b border-slate-100 pb-2" data-id="element-134">
          Business Tools & Services
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-135">
          {businessCats.map((cat, i) => <CategoryCard key={i} {...cat} data-id="element-136" />)}
        </div>
      </div>

      <div data-id="element-137">
        <h3 className="text-xs font-bold text-slate-400 uppercase tracking-wider mb-4 border-b border-slate-100 pb-2" data-id="element-138">
          Rep Resources & Career
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4" data-id="element-139">
          {repCats.map((cat, i) => <CategoryCard key={i} {...cat} data-id="element-140" />)}
        </div>
      </div>
    </SectionWrapper>;
}